/* eslint-disable eqeqeq */
// validates year/month/day ranges
const validateDate = (year, month, day) => {
  // Check the ranges of month and year
  const invalidRangeYear = year < 0 || year > 3000;
  const invalidRangeMonth = month == 0 || month > 12;

  if (invalidRangeYear || invalidRangeMonth) return false;

  // Check the range of the day
  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  // Adjust for leap years
  if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
    monthLength[1] = 29;
  }

  const validRangeDay = day > 0 && day <= monthLength[month - 1];
  return validRangeDay;
};

export default validateDate;



// WEBPACK FOOTER //
// ./src/utils/validateDate.js